import axios from "@/axios/axios";
// Delete Test Goals
export async function fetchTestGoals(prjid: string): Promise<{ _id: string }[]> {
  try {
    const res = await axios.get(`tstgoal/all/${prjid}`);
    return res ? res.data : []
  } catch (e) {
    // console.log('Error post request :', e.message);
    return []
  }
}
export async function deleteTestGoal(tgId: string): Promise<boolean> {
  try {
    const res = await axios.delete(`tstgoal/${tgId}`);
    return res && res.status === 200
  } catch (e: any) {
    console.log('Error post request :', e.message);
    return false;
  }
}

// Delete Test Cases
export async function fetchTestcases(prjid: string): Promise<{ _id: string }[]> {
  try {
    const res = await axios.get(`tstcase/all/${prjid}`);
    return res ? res.data : []
  } catch (e) {
    // console.log('Error post request :', e.message);
    return []
  }
}
export async function deleteTestcase(tcId: string): Promise<boolean> {
  try {
    const res = await axios.delete(`tstcase/${tcId}`);
    return typeof res.data === 'boolean';
  } catch (e) {
    // console.log('Error post request :', e.message);
    return false;
  }
}

// Delete Jobs
export async function fetchJobs(prjid: string): Promise<{ _id: string }[]> {
  try {
    const res = await axios.get(`job/all/${prjid}`);
    return res ? res.data : []
  } catch (e) {
    // console.log('Error post request :', e.message);
    return []
  }
}
export async function deleteJob(jobid: string): Promise<boolean> {
  try {
    await axios.delete(`job/${jobid}`);
    return true;
  } catch (e) {
    // console.log('Error post request :', e.message);
    return false;
  }
}

// Delete Screens
export async function fetchAllScreens(prjid: string): Promise<{ _id: string }[]> {
  try {
    const res = await axios.get(`screen/project/${prjid}`);
    // console.log(`fetch ${res.data.length} screens`)
    return res.data;
  } catch (e) {
    return [];
  }
}
export async function deleteScreen(scrId: string): Promise<boolean> {
  try {
    const res = await axios.delete(`/screen/${scrId}`);
    return res ? res.data : false;
  } catch (e) {
    return false;
  }
}

// Delete Tools
export async function fetchTools(prjid: string): Promise<{ _id: string }[]> {
  try {
    const res = await axios.post(`/tobject/tools`, {prjid});
    return res ? res.data : [];
  } catch (e) {
    return [];
  }
}
export async function deleteTobject(tid: string): Promise<boolean> {
  try {
    const res = await axios.delete(`/tobject/${tid}`);
    return res ? res.status === 200: false;
  } catch (e) {
    return false;
  }
}

// Delete Buffers
export async function fetchBuffers(prjid: string): Promise<{ _id: string }[]> {
  try {
    const res = await axios.get(`/buffer/all/${prjid}`);
    return res ? res.data : [];
  } catch (e) {
    return [];
  }
}
export async function deleteBuffer(rushid: string): Promise<void> {
  try {
    await axios.delete(`/buffer/rush/${rushid}`)
    return
  } catch (e) {
    console.log('deleteBuffer failed :', e)
    return
  }
}

// Delete Releases
export async function deleteReleases(prjid: string): Promise<void> {
  try {
    await axios.delete(`/release/all/${prjid}`)
    return
  } catch (e) {
    console.log('deleteReleases failed :', e)
    return
  }
}

// Delete Terminals
export async function fetchTerminals(prjId: string): Promise<{ _id: string }[]> {
  try {
    const result = await axios.get(`/term/all/${prjId}`)
    return result ? result.data : []
  } catch (e) {
    return []
  }
}
export async function removeTerminal(termId: string): Promise<boolean> {
  try {
    const result = await axios.delete(`/term/${termId}`)
    return result && result.status === 200
  } catch (e) {
    return false
  }
}

// Delete Variables
export async function allVariables(prjid: string): Promise<{ _id: string }[]> {
  try {
    const result = await axios.get(`/variable/all/${prjid}`)
    return result ? result.data : []
  } catch (e) {
    console.log('Failed allVariables', e)
    return []
  }
}
export async function deleteVariable(varid: string): Promise<boolean> {
  try {
    const result = await axios.delete(`/variable/${varid}`)
    return result && result.status === 200
  } catch (e) {
    console.log('Failed allVariables', e)
    return false
  }
}

// Delete tree nodes
export async function deleteProjectTreeNodes(prjid: string): Promise<void> {
  try {
    await axios.delete(`/tnode/project/${prjid}`)
    return
  } catch (e) {
    console.log('deleteProjectTreeNodes failed :', e)
    return
  }
}

// Delete project
export async function deleteProject(prjid: string): Promise<void> {
  try {
    await axios.delete(`/prj/${prjid}`)
    return
  } catch (e) {
    console.log('deleteProject failed :', e)
    return
  }
}
